import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose, lifecycle, withProps } from "recompose";

import { withOverlay } from "@dpdgroupuk/mydpd-ui";

import withOnLoadFailure from "../../../../HOCS/withOnLoadFailure";
import withReportFeedbackHandler from "../../../../HOCS/withReportFeedbackHandler";
import {
  getLocationState,
  getQueryPagination,
  getSearchQuery,
  stringifyQuery,
} from "../../../../utils/query";
import { fetchRelatedParcels } from "../../actions";
import { getRelatedParcels, getRelatedParcelsTotal } from "../../selectors";

export default compose(
  withRouter,
  withReportFeedbackHandler,
  withOnLoadFailure,
  withOverlay,
  connect(null, (dispatch, { parcelCode }) => ({
    findParcels: (query, fetchOptions) =>
      dispatch(fetchRelatedParcels(parcelCode, query, fetchOptions)),
  })),
  connect(
    state => ({
      totalCount: getRelatedParcelsTotal(state),
      relatedParcels: getRelatedParcels(state),
    }),
    (_, { history, location }) => {
      const onNextOrPrev = targetPage => {
        const query = getSearchQuery(location);

        history.push({
          search: stringifyQuery({
            ...query,
            page: targetPage,
          }),
          state: getLocationState(location),
        });
      };

      return {
        onNext: onNextOrPrev,
        onPrevious: onNextOrPrev,
        onFirst: onNextOrPrev,
        onLast: onNextOrPrev,
      };
    }
  ),
  withProps(({ location }) => ({
    ...getQueryPagination(location),
  })),
  lifecycle({
    async componentDidUpdate(prevProps) {
      const { search } = this.props.location;
      const { search: prevSearch } = prevProps.location;

      if (prevSearch !== search) {
        try {
          this.props.overlay.show();
          const pageQuery = getQueryPagination(this.props.location);
          await this.props.findParcels(pageQuery);
        } finally {
          this.props.overlay.hide();
        }
      }
    },
    componentWillUnmount() {
      this.props.history.replace({
        search: "",
      });
    },
  })
);
